import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Contas from '../../../components/contas/contas'


function ContasScreen() {
    return (
        <Fragment>
            <Head titulo="Prestação de Contas da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/contas'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Alert variant='danger'>
                    ATENÇÃO: Devivo ao tamanho dos arquivos de prestação de contas, seu carregamento será demorado. Aguarde com paciência que o arquivo SERÁ carregado após alguns minutos.
                    <br /><br />
                    Arquivos mais pesados:
                    <br />
                    Exercício 2017-2 - 496 MEGABYTES (0,5GB) - 795 páginas - Tempo estimado em uma internet de 100Megabits: 40 minutos<br />
                    Exercício 2018 - 374 MEGABYTES (0,4GB) - 711 páginas - Tempo estimado em uma internet de 100Megabits: 30 minutos<br />
                    Exercício 2019 - 214 MEGABYTES (0,2GB) - 1050 páginas Tempo estimado em uma internet de 100Megabits: 15 minutos<br /><br />
                </Alert>
               <Contas />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ContasScreen;